/**
 * tdesign v0.48.5
 * (c) 2022 tdesign
 * @license MIT
 */

var calcSize = function calcSize(width) {
  var size = "xs";

  if (width < 768) {
    size = "xs";
  } else if (width >= 768 && width < 992) {
    size = "sm";
  } else if (width >= 992 && width < 1200) {
    size = "md";
  } else if (width >= 1200 && width < 1400) {
    size = "lg";
  } else if (width >= 1400 && width < 1880) {
    size = "xl";
  } else {
    size = "xxl";
  }

  return size;
};

export { calcSize };
//# sourceMappingURL=responsive.js.map
